export { createManuscriptPanel, DEFAULT_LABELS } from './manuscript-panel.js';
export { createZoomController, ZOOM_DEFAULTS } from './zoom.js';
export { createRouter } from './router.js';
export * as hebrew from './hebrew.js';
export { nearestEntry } from './resolve.js';
export * as bbox from './bbox.js';

// Selection core + layer registry: the substrate every apparatus plugs into.
export { createSelection } from './selection.js';
export { createDock, DOCK_LABELS } from './dock.js';
export { createLayerRegistry } from './layers.js';
export { createCommentaryPanel, COMMENTARY_LABELS } from './commentary-panel.js';
export * as address from './address.js';

// Transcription marks → reading layers (shared with mishnah-viewer's reader).
export * as marks from './marks.js';
